import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import { formatMessage } from '@99designs/common/i18n';
import Link from 'launch/components/Link';
import ContentSetting from 'projects/components/ContentSetting';
import Layout from 'projects/components/Layout';
import * as React from 'react';

interface Props {
    heading: React.ReactNode;
    message: React.ReactNode;
    chameleon?: string;
    error?: { message: string };
}

const Error: React.SFC<Props> = ({ heading, message, chameleon, error }) => (
    <ContentSetting>
        <div className="fullscreen-error">
            <div className="fullscreen-error__details">
                <h1
                    className="heading heading--h1 heading--with-divider"
                    style={{ color: chameleon }}
                >
                    {heading}
                </h1>
                <p>{message}</p>
                {error && process.env.NODE_ENV !== 'production' ? (
                    <p className="subtle-text">{error.message}</p>
                ) : null}

                <ButtonGroup variations={['responsive']}>
                    <ButtonGroupItem>
                        <Link href={'/'}>
                            <Button
                                variations={['jumbo', 'fluid', 'primary']}
                                style={{ backgroundColor: chameleon, borderColor: chameleon }}
                            >
                                {__('Get me outta here')}
                            </Button>
                        </Link>
                    </ButtonGroupItem>
                    <ButtonGroupItem>
                        <Link href={'/help'}>
                            <Button
                                variations={['jumbo', 'fluid', 'secondary']}
                                style={{
                                    backgroundColor: 'white',
                                    borderColor: chameleon,
                                    color: chameleon,
                                }}
                            >
                                {__('Help')}
                            </Button>
                        </Link>
                    </ButtonGroupItem>
                </ButtonGroup>
            </div>

            <div className="fullscreen-error__artwork">
                <img className="image-box__img" src={require('images/errors/dog_alinasink.jpg')} />
                <span className="attribution    fullscreen-error__attribution">
                    {formatMessage(__('by {designer}'), { designer: 'ALINAsINK' })}
                </span>
            </div>
        </div>
    </ContentSetting>
);

Error.defaultProps = {
    chameleon: '#F36C78',
};

const ErrorPage: React.SFC<Props> = props => (
    <Layout>
        <Error {...props} />
    </Layout>
);
export default ErrorPage;
